import { shape, string, number, array } from 'prop-types';
import trackingDeviceShape from './trackingDeviceShape';

export default shape({
  id: string,
  lat: number,
  lng: number,
  segments: array,
  name: string,
  trackingDevice: trackingDeviceShape,
});



// WEBPACK FOOTER //
// ./src/propTypes/locationShape.js